import { render, staticRenderFns } from "./PageMessagesView.vue?vue&type=template&id=2dfcdac0&"
import script from "./PageMessagesView.vue?vue&type=script&lang=js&"
export * from "./PageMessagesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports